<tpm-dialog-frame alt-theme [hasFooter]="false" [header]="data.title | translate">
  <div class="content-container">
    <h3 class="heading">{{ "LAUNCHPAD.STORYTELLER.CONTENT_TITLE" | translate }}</h3>
    <tpm-audio-player class="player" *ngIf="data.media?.type === 'audio'" [source]="data.media?.url"></tpm-audio-player>
    <div *ngIf="data.description">
      <h3>{{ "LAUNCHPAD.STORYTELLER.TRANSCRIPTION_LABEL" | translate }}</h3>
      <p class="body-md" [innerHTML]="data.description | translate"></p>
    </div>
  </div>
</tpm-dialog-frame>
